import {useEffect, useState} from 'react'

import {useSuiContext} from '@s-ui/react-context'
import {useAdvertising} from '@adv-mt/advertising-publift'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'
import {DECODING, FETCH_PRIORITY, LOADING, MediaImage, OBJECT_FIT} from '@adv-mt/ui/media-image'

import {BASE_CLASS as PAGE_BASE_CLASS} from '../../../config.js'
import AdvantageCard from '../advantageCard/index.js'
import {clickUrlTransformationService, stripClickUrlMacros} from './clickUrlTransformationService.js'

const BASE_CLASS = `${PAGE_BASE_CLASS}-advantages-insurance`

const Insurance = () => {
  const {domain, i18n} = useSuiContext()
  const {track: analyticsTrack} = useAnalyticsTrack()
  const {advertisingPageData} = useAdvertising()

  const config = domain.get('config')
  const {
    EVENT_CHANNEL_INSURANCE,
    EVENT_ID_DETAIL_CLICKED,
    EVENT_INSURANCE_CLICKED,
    INSURANCE_DETAIL_CARD_LOGOS,
    URL_INSURANCE_BUTTON
  } = config.get('advertising')

  // Seeded, never null: the anchor must ship from the server with a working href and stay focusable
  const [href, setHref] = useState(stripClickUrlMacros(URL_INSURANCE_BUTTON))

  useEffect(() => {
    if (!advertisingPageData) return
    setHref(clickUrlTransformationService({clickUrl: URL_INSURANCE_BUTTON, pageData: advertisingPageData}))
  }, [advertisingPageData, URL_INSURANCE_BUTTON])

  const handleClick = () => {
    analyticsTrack({
      event: EVENT_INSURANCE_CLICKED,
      data: {channel: EVENT_CHANNEL_INSURANCE, event_id: EVENT_ID_DETAIL_CLICKED}
    })
  }

  return (
    <AdvantageCard
      href={href}
      onClick={handleClick}
      title={i18n.t('COMMON.DETAIL_ADVANTAGES_INSURANCE_TITLE')}
      description={i18n.t('COMMON.DETAIL_ADVANTAGES_INSURANCE_DESCRIPTION')}
    >
      <div className={`${BASE_CLASS}-logos`}>
        {INSURANCE_DETAIL_CARD_LOGOS.map(({name, url}) => (
          <MediaImage
            key={url}
            src={url}
            alt={name}
            objectFit={OBJECT_FIT.CONTAIN}
            loading={LOADING.LAZY}
            decoding={DECODING.ASYNC}
            fetchPriority={FETCH_PRIORITY.LOW}
            className={`${BASE_CLASS}-logosImage`}
          />
        ))}
      </div>
    </AdvantageCard>
  )
}

Insurance.displayName = 'Insurance'

export default Insurance
